var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "sort-list"
  }, [_vm._m(0), _c('draggable', {
    staticClass: "sortlist",
    attrs: {
      "tag": "ul",
      "list": _vm.items,
      "animation": 150,
      "no-transition-on-drag": true
    },
    on: {
      "change": _vm.sortChange
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: item.name,
      staticClass: "item",
      style: _vm.itemStyle,
      attrs: {
        "title": item.label
      }
    }, [_c('el-checkbox', {
      staticClass: "item__control",
      attrs: {
        "border": "",
        "size": "small"
      },
      on: {
        "change": function ($event) {
          return _vm.checkChange(index, $event);
        }
      },
      model: {
        value: item.show,
        callback: function ($$v) {
          _vm.$set(item, "show", $$v);
        },
        expression: "item.show"
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")])], 1);
  }), 0)], 1);
};

var staticRenderFns = [function () {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "mb-4"
  }, [_c('span', {
    staticClass: "sort-panel-header"
  }, [_vm._v("自定义列")]), _c('span', {
    staticClass: "el-alert--warning is-light"
  }, [_vm._v("（请在字段名称上按住鼠标左键拖拽进行排序）")])]);
}];
export { render, staticRenderFns };